import { apiSlice } from "../apiSlice";

const paymentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPaymentRequestList: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/payment-req-list/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['paymentRequest']
        }),
        getPaymentRequest: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/payment-req/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['paymentRequest']
        }),
        createPaymentRequest: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/merchant/payment-request`,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags: ['paymentRequest']
        }),
    }),
    overrideExisting: true,
});

export const { useGetPaymentRequestListQuery, useGetPaymentRequestQuery, useCreatePaymentRequestMutation } = paymentApiSlice;
